/**
 * champis-forum's "Modifier" (components/EditPostButton), only the pencil,
 * next to an entry of the glossary, books or links: the edit composer for
 * its text, for whoever may edit it. Looked up at render time through
 * flarum.reg - an extension's code isn't importable by another (see
 * BooksPage's getSpeciesSearchWidget()).
 */
export default function editPostButton(post) {
  const EditPostButton = window.flarum.reg.get('champis-forum', 'forum/components/EditPostButton');
  return EditPostButton ? m(EditPostButton, {
    post,
    compact: true
  }) : null;
}
flarum.reg.add('champis-others', 'forum/utils/editPostButton', editPostButton);